import React from 'react';
import CalculatorStep from './CalculatorStep';
import PropTypes from 'prop-types';

class Step1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: this._evaluateAnswers(props.answers)
    };

    this.isValidated = this.isValidated.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // Called when the user attempts to advance to the next step
  isValidated() {
    let isDataValid = Boolean(this.state.answers[0].isValid);

    if (isDataValid) {
      this.props.onSubmit(this.state.answers);
    } else{
      this.setState(state =>
        state.answers.map(answer => {
          answer.validationState = 'error';
          answer.validationMessage = "Please enter a valid, nonzero value.";
        })
      );
    } 

    return isDataValid;
  }

  handleChange(questionNumber, value) {
    const previousAnswer = this.state.answers[questionNumber];
    if (typeof previousAnswer !== 'undefined' && previousAnswer.value === value) {
      return; // No update - nothing changed
    }

    this.setState(state => {
      let answers = state.answers;

      // Evaluate the validity of the form and update state
      return { answers: this._evaluateAnswer(answers, questionNumber, value) };
    });
  }

  _evaluateAnswers(answers) {
    answers.forEach((answer, i) => {
      answers = this._evaluateAnswer(answers, i, answer.value);
    });

    return answers;
  }

  _evaluateAnswer(answers, currentQuestionNumber, newValue) {
    newValue = newValue.trim().length > 0 ? newValue : "0";
    const isValid = typeof newValue !== 'undefined' && parseInt(newValue) > 0;

    answers.forEach((answer, i) => {
      if (i === currentQuestionNumber) {
        answer.value = newValue,
        answer.timestamp = new Date(),
        answer.isValid = isValid,
        answer.validationState = isValid ? 'success' : null,
        answer.validationMessage = isValid ? null : answer.validationMessage;
      }
      
      answers[i] = answer;
    });

    return answers;
  }

  render() {
    const questions = this.props.questions.map((question, i) => {
      const answer = this.state.answers[i];
      question.validationState = answer.validationState;
      question.validationMessage = answer.validationMessage;
      question.defaultValue = answer.value;
      
      return question;
    });

    return (
      <CalculatorStep
          name={"averageOrderValue"}
          questions={questions}
          handleChange={this.handleChange}
          articleKey="order"
      />
    );
  }
}

Step1.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.int,
      timestamp: PropTypes.dateTime
    }).isRequired
  ),
  onSubmit: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      required: PropTypes.bool,
      type: PropTypes.string
    })
  ).isRequired
};

export default Step1;
